var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.uiconfig.layoutType,{ref:"layout",tag:"component",attrs:{"config":_vm.uiconfig,"dictData":_vm.globalConfig.dictData,"moduleMethod":_vm.globalConfig.userModuleMethod,"defaultExport":_vm.defaultExport},on:{"doAction":_vm.doAction}}),_vm._v(" "),_c('BillExcelImport',{ref:"billImport",attrs:{"config":_vm.billImportConfig}}),_vm._v(" "),_c('BirtReportBox',{ref:"report"})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/layouttemplate/layouttemplate.vue